import type { Network, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';
import { getCurrentNetworkId } from '../session/selectors';

/**
 * @deprecated PERFORMANCE This selects an entity object and will return a new object instance when it changes,
 * causing unnecessary re-renders in consuming components. This should be replaced by a `getNetworkField` selector.
 */
export const findById = createFindById('networks');
/**
 * @deprecated PERFORMANCE This selects an entity object and will return a new object instance when it changes,
 * causing unnecessary re-renders in consuming components. This should be replaced by a `getNetworkFieldThrows` selector.
 */
export const findByIdThrows = createFindByIdThrows('networks');

type GetCurrentNetwork = (state: YammerState) => Network;
/**
 * @deprecated PERFORMANCE This selects an entity object and will return a new object instance when it changes,
 * causing unnecessary re-renders in consuming components. This should be replaced by a `getCurrentNetworkField` selector.
 */
export const getCurrentNetwork: GetCurrentNetwork = (state) => {
  const currentNetworkId = getCurrentNetworkId(state);

  return findByIdThrows(state, currentNetworkId);
};

type GetFulfilledNetworks = (state: YammerState) => Record<string, Network>;
/**
 * @deprecated PERFORMANCE This selects ALL fulfilled networks in the entire store, forcing re-renders in consumers
 * whenever ANY network changes. This should be deleted.
 */
export const getFulfilledNetworks: GetFulfilledNetworks = (state) => state.networks.fulfilled.byId;

type GetNetworkPermalinkById = (state: YammerState, networkId: Network['id']) => Network['permalink'] | undefined;
export const getNetworkPermalinkById: GetNetworkPermalinkById = (state, networkId) => {
  const network = findById(state, networkId);

  return network?.permalink;
};
